import Highcharts from 'highcharts';
import { CSSProperties, FC, useEffect } from 'react';

export interface TChartProps {
  modules?: ((highcharts: typeof Highcharts) => void)[];
  container: string;
  options: Highcharts.Options;
  type?: string;
  className?: string;
  style?: CSSProperties;
}

export const Chart: FC<TChartProps> = (props: TChartProps) => {
  let chart: Highcharts.Chart | null;

  // Extend Highcharts with any passed modules.
  if (props.modules) {
    props.modules.forEach((module) => {
      module(Highcharts);
    });
  }

  useEffect(() => {
    if (chart) {
      chart.destroy();
    }
    // Set container which the chart should render to.
    chart = new (Highcharts as any)[props.type || 'Chart'](props.container, props.options);

    // A function returned from useEffect will be called when the component unmounts.
    return () => {
      // Destroy chart on unmount.
      if (chart && chart.destroy) {
        chart.destroy();
        chart = null;
      }
    };
  });

  // Create the div which the chart will be rendered to.
  return (
    <div className={props.className} style={props.style}>
      <div id={props.container} />
    </div>
  );
};

export default Chart;
